import template from './employee_search_component.html';

class EmployeeSearchComponentViewModel
{
	constructor (params)
	{
		this.params = params;

		this.employees = ko_helper.safe_observableArray();
		this.selected_employee = ko_helper.safe_observable(params.selected_employee || '');
		this.selected_department = ko_helper.safe_observable(params.selected_department || '');
		this.search_string = ko.observable('');

		// Computed observable for dynamically updating the placeholder
		this.placeholderText = ko.pureComputed(() => {
			return this.selected_employee() != null ? `${this.selected_employee().firstname} ${this.selected_employee().surname} (${this.selected_employee().id_number})` : "Search employee...";
		});

		this.search_string.subscribe((newValue) => {
			this.updateData();
		});

		// Subscribe to department changes to update data
		this.selected_department.subscribe((newValue) => {
			this.updateData();
		});
	}

	async init()
	{
		await this.updateData();
	}

	async updateData()
	{
		let options = {
			table: 'v_active_employees_department',
			schema: 'savanna',
			limit: 1000000,
			fields: ['id_number', 'firstname', 'surname', 'employee_id', 'email', 'date_started', 'department_id']
		};

		// If we have a search string, perform full text search across multiple fields
		if (this.search_string() && this.search_string().trim() !== '')
		{
			let search_term = this.search_string().trim();
			let search_words = search_term.split(/\s+/); // Split on whitespace
			
			// Create queries based on search pattern
			let queries = [];
			
			// Base filter for department if selected
			let base_filter = [];
			if (this.selected_department() && this.selected_department().department_id)
			{
				base_filter.push({
					field: 'department_id',
					operand: '=',
					value: this.selected_department().department_id
				});
			}
			
			// If multiple words, try different combinations for firstname + surname
			if (search_words.length >= 2)
			{
				// Try different split points to handle multi-word firstnames
				
				for (let i = 1; i < search_words.length; i++)
				{
					let potential_firstname = search_words.slice(0, i).join(' ');
					let potential_surname = search_words.slice(i).join(' ');
					
					// Query: firstname matches potential_firstname AND surname matches potential_surname
					queries.push(Grape.fetches.getJSON('/api/record', {
						...options,
						filter: [
							...base_filter,
							{
								field: 'firstname',
								operand: 'ILIKE',
								value: `%${potential_firstname}%`
							},
							{
								field: 'surname',
								operand: 'ILIKE',
								value: `%${potential_surname}%`
							}
						]
					}));
				}
			}
			// Query: Search by firstname
			queries.push(Grape.fetches.getJSON('/api/record', {
				...options,
				filter: [
					...base_filter,
					{
						field: 'firstname',
						operand: 'ILIKE',
						value: `%${search_term}%`
					}
				]
			}));

			// Query: Search by surname
			queries.push(Grape.fetches.getJSON('/api/record', {
				...options,
				filter: [
					...base_filter,
					{
						field: 'surname',
						operand: 'ILIKE',
						value: `%${search_term}%`
					}
				]
			}));

			// Query: Search by id_number
			queries.push(Grape.fetches.getJSON('/api/record', {
				...options,
				filter: [
					...base_filter,
					{
						field: 'id_number',
						operand: 'ILIKE',
						value: `%${search_term}%`
					}
				]
			}));

			// Execute all queries in parallel
			let results = await Promise.all(queries);

			// Combine and deduplicate results
			let combined_results = [];
			let seen_ids = new Set();

			results.forEach(result => {
				if (result.status !== 'ERROR' && result.records)
				{
					result.records.forEach(record => {
						if (!seen_ids.has(record.employee_id))
						{
							combined_results.push(record);
							seen_ids.add(record.employee_id);
						}
					});
				}
			});

			// Sort results with priority: exact full name matches first, then partial matches
			combined_results.sort((a, b) => {
				let full_name_a = `${a.firstname} ${a.surname}`.toLowerCase();
				let full_name_b = `${b.firstname} ${b.surname}`.toLowerCase();
				let search_lower = search_term.toLowerCase();
				
				// Prioritize exact matches
				let a_exact = full_name_a.includes(search_lower);
				let _bExact = full_name_b.includes(search_lower);
				
				if (a_exact && !_bExact) return -1;
				if (!a_exact && _bExact) return 1;
				
				// Then sort by lastname, then firstname
				let last_name_compare = a.surname.localeCompare(b.surname);
				if (last_name_compare !== 0) return last_name_compare;
				return a.firstname.localeCompare(b.firstname);
			});

			this.employees(combined_results);
		}
		else if (this.selected_department() && this.selected_department().department_id)
		{
			let department_options = {
				...options,
				filter: [{
					field: 'department_id',
					operand: '=',
					value: this.selected_department().department_id
				}]
			};

			let result = await Grape.fetches.getJSON('/api/record', department_options);
			
			if (result.status !== 'ERROR' && result.records != null)
				this.employees(result.records);
			else
				this.employees([]);
		}
		else
		{
			let all_options = {
				...options,
				limit: 100 // Limit to first 100 employees when no filters
			};

			let result = await Grape.fetches.getJSON('/api/record', all_options);
			
			if (result.status !== 'ERROR' && result.records != null)
				this.employees(result.records);
			else
				this.employees([]);
		}
	}

	employee_click (selected)
	{
		this.selected_employee(selected);
		this.search_string('');
	}

	clear_selected_option ()
	{
		this.selected_employee(null);
		this.search_string('');
	}
}

export default {
	name: 'employee_search_component',
	viewModel: EmployeeSearchComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_search_component'
};